import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { changeLanguage as changeAppLanguage } from '../../actions/app';
import UserInfo from './../../containers/UserInfo/';

import CenteredImage from '../CenteredImage';
import './navigation.scss';

class Navigation extends Component {

  constructor(props) { // eslint-disable-line
    super(props);
  }

  changeLanguage(newLanguage) {
    changeAppLanguage(newLanguage);
  }

  render() {
    const { userIdentified, openCancelReservationScreen, logout, viaSso, t } = this.props;
    const logoSize = {
      height: '60px',
      width: '150px'
    };
    const handleLogout = () => {
      logout(viaSso);
    };

    return (
      <Navbar fixedTop fluid>
        <Navbar.Header>
          <Navbar.Brand>
            <CenteredImage alt={t('common:ariaLabels.brandImage')} containerHeight={logoSize.height} containerWidth={logoSize.width} src={this.props.organizationLogoUrl} />
          </Navbar.Brand>
          { userIdentified && <Navbar.Toggle /> }
        </Navbar.Header>
        { userIdentified &&
          <Navbar.Collapse>
            <Nav pullRight aria-label={t('common:ariaLabels.navBarRight')}>
              <NavDropdown
                className="menu-item"
                eventKey={2}
                title={<UserInfo />}
                id="user-dropdown"
              >
                <MenuItem onSelect={openCancelReservationScreen}>{t('booking:cancelReservation.startCancelling')}</MenuItem>
              </NavDropdown>
              <NavItem className="logout-button menu-item" onSelect={handleLogout}>{t('menuItems.account.logout')}</NavItem>
            </Nav>
          </Navbar.Collapse>
        }
      </Navbar>
    );
  }
}

Navigation.propTypes = {
  userIdentified: PropTypes.bool.isRequired,
  organizationLogoUrl: PropTypes.string.isRequired,
  openCancelReservationScreen: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  viaSso: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired
};

export default translate(['common'], { wait: true })(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.jsx